module.exports = __webpack_public_path__ + "img/9.09029aa2.png";